import { GoabText } from '@abgov/angular-components';
import { Component } from '@angular/core';

@Component({
  selector: 'app-getting-numbers-right',
  imports: [GoabText],
  templateUrl: './getting-numbers-right.html',
  styleUrl: './getting-numbers-right.scss',
})
export class GettingNumbersRight {}
